<!-- header -->
<app-app-nav></app-app-nav>
<!-- END header -->

<main id="mainContent" tabindex="-1" class="">
  <!-- whatsapp floating button -->
  <app-whatsapp></app-whatsapp>
  <!-- END whatsapp floating button -->
  <div class="container-fluid position-relative">
    <div class="row bg-secondary py-4">
      <div class="col">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb animate__animated animate__fadeInDown mb-0">
            <li class="breadcrumb-item mb-2 mb-md-0">
              <a class="text-white" routerLink="/">أكادميه الفنون</a>
            </li>
            <li class="breadcrumb-item mb-2 mb-md-0">
              <a class="text-white" (click)="go_to_list()" role="button" tabindex="0" (keydown.enter)="go_to_list()" (keydown.space)="go_to_list()">
                دراسات و بحوث
              </a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ reserch_details.TITLE }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <section class="row pb-5 pt-4 animate__animated animate__fadeIn animate__fast wow">
      <div class="col-lg-8 col-xl-9 ps-lg-4 course-details">

        <h1>{{ reserch_details.TITLE }}</h1>
        <label *ngIf="reserch_details.faculty_name"
          class="badge bg-primary-light py-1 px-2 lh-base text-black d-inline-block mt-2">
          {{ reserch_details.faculty_name }}
        </label>
        <div class="position-relative mt-4">
          <img src="{{reserch_details.IMG_PATH}}" alt="" />
        </div>
        <div class="position-relative pt-4">
          <div class="mb-4">
            <h5 class="fw-bold text-black mb-2">التفاصيل</h5>
            <p class="text-muted fw-medium news-body">
              {{ reserch_details.DETAILS }}
            </p>
          </div>

          <!-- Research link (LINK) -->
          <div class="news-links" *ngIf="reserch_details.LINK">
            <h3 class="news-section-title heading-font">رابط البحث</h3>
            <ul class="news-links-list">
              <li>
                <a [href]="reserch_details.LINK" target="_blank" rel="noopener noreferrer">
                  <svg class="news-link-icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                  </svg>
                  <span>الاطلاع على البحث</span>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
      <aside class="col-lg-4 col-xl-3 mt-lg-5 pt-5" *ngIf="otherResearch.length">
        <div class="border px-3 pt-4">
          <h3>أبحاث أخرى</h3>
          <ul class="list-unstyled fw-medium fs-7">
            <li class="border-top py-4 px-1" *ngFor="let item of otherResearch">
              <a class="text-black hover" (click)="Details(item)" role="button" tabindex="0" (keydown.enter)="Details(item)" (keydown.space)="Details(item)">{{ item.TITLE }}</a>
            </li>
          </ul>
        </div>
      </aside>
    </section>
  </div>
  <section class="container-fluid pt-lg-5 pt-3 pb-lg-5 pb-3">
    <div class="row">
      <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__faster wow">
        <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
          <div class="fw-medium flex-fill p-1">
            موقع الطالب
            <p class="mb-0 text-gray mt-1">تعرف على المواد و المهام و النتيجة</p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
      <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
        <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
          <div class="fw-medium flex-fill p-1">
            موقع هيئة التدريس
            <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
      <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp animate__fast wow">
        <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
          <div class="fw-medium flex-fill p-1">
            موقع الموظفين
            <p class="mb-0 text-gray mt-1">تابع متطلبات الطلبه</p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
      <div class="col-lg-3 col-md-6 mb-lg-0 mb-3 pb-lg-0 pb-3 animate__animated animate__fadeInUp wow">
        <a class="btn caption border d-flex align-items-center text-start p-3 fs-6 h-100">
          <div class="fw-medium flex-fill p-1">
            خدمات الخريجين
            <p class="mb-0 text-gray mt-1">تعرف على الخدمات الخاصه بالخرجين</p>
          </div>
          <i class="icon-arrow-sm m-1 default d-block overflow-hidden"></i>
        </a>
      </div>
    </div>
  </section>
</main>
